import { render, staticRenderFns } from "./ErrorMessages.vue?vue&type=template&id=53063a08&scoped=true&"
import script from "./ErrorMessages.vue?vue&type=script&lang=ts&"
export * from "./ErrorMessages.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorMessages.vue?vue&type=style&index=0&id=53063a08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53063a08",
  null
  
)

export default component.exports